import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { User } from "../models/user";

type UserState = {
  user?: User;
  setUser: (user: User) => void;
  clearUser: () => void;
};

export const useUserState = create<UserState>()(
  persist(
    (set) => ({
      setUser: (user) =>
        set(() => ({
          user,
        })),
      clearUser: () =>
        set(() => ({
          user: undefined,
        })),
    }),
    {
      name: "user-state",
      storage: process.env.NODE_ENV === "development" ? createJSONStorage(() => localStorage) : undefined,
    },
  ),
);
